export default function (val, precision, classs) {
  const number = Number.parseFloat(val)
  const w = 10000 //万
  const y = 100000000 //亿

  const formatF2 = number => {
    if (number > y || number < -y) {
      return (number / y).toFixed(2) + '亿'
    } else if ((w < number && number < y) || (-y < number && number < -w)) {
      return (number / w).toFixed(2) + '万'
    } else {
      return number.toFixed(2)
    }
  }
  
  const options = {
    'ps4': number.toFixed(4),
    'f2': formatF2(number),
    'p2': number.toFixed(2) + '%',
    'tongbi': (number*100).toFixed(2) + '%'
  }
  return number ? options[precision] : (classs == '大类') ? null : '- -'
}

